// extracted by mini-css-extract-plugin
module.exports = {"header":"flex_header__QIaoO","headTitle":"flex_headTitle__e_A__","wrapper":"flex_wrapper__qR0T3"};